// extracted by css-extract-rspack-plugin
export default {"Root":"NTWGi","text":"wIBHC"};